import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <Section className="pb-16" data-id="element-88">
      <div className="max-w-3xl mx-auto text-center" data-id="element-89">
        <p className="text-xl md:text-2xl text-zinc-300 mb-10" data-id="element-90">
          Deja de regalar tu atención y recupera tu derecho a producir con
          calidad. El acceso a la Maquinaria de Enfoque no cuesta los miles de
          dólares que pierdes en tiempo desperdiciado cada mes.
        </p>

        <div id="pricing" className="bg-tactical-light border-2 border-accent p-8 md:p-12 relative mb-10" data-id="element-91">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-white font-oswald uppercase px-4 py-1 text-sm tracking-widest" data-id="element-92">
            Oferta Especial
          </div>

          <div className="flex flex-col items-center justify-center mb-8" data-id="element-93">
            <span className="text-zinc-500 text-2xl line-through mb-2" data-id="element-94">
              $87
            </span>
            <div className="flex items-start relative" data-id="element-95">
              <span className="text-3xl text-accent font-bold mt-2" data-id="element-96">$</span>
              <span className="text-7xl md:text-8xl font-bold text-white font-oswald" data-id="element-97">
                6.39
              </span>
              <span className="absolute -top-2 -right-16 bg-green-600 text-white text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wide" data-id="element-98">
                93% off
              </span>
            </div>
            <p className="text-zinc-400 mt-2" data-id="element-99">
              Pago único. Acceso de por vida.
            </p>
          </div>

          <CTAButton className="w-full text-xl md:text-2xl py-5 mb-6" href="https://www.recursosencalma.com/cart/45888050167981:1" data-id="element-100">
            Elimina tus pendientes ahora
          </CTAButton>

          <div className="flex items-center justify-center gap-2 text-zinc-400 text-sm" data-id="element-101">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-102" />
            <span data-id="element-103">Acceso instantáneo al PDF tras el pago seguro</span>
          </div>
        </div>
      </div>
    </Section>;
}